import './expo_page.css';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate

import { useTranslation } from 'react-i18next';

import cptimg from './cpt_icon_saas.png';
import borimg from './borehole_icon_saas.png';
import dvp from './sviluppo.png';
import tut from './tutorial.png';
import gd from './guide.png';

function Sw_dash() {

    const { t } = useTranslation();
    const navigate = useNavigate(); // Create a navigate function

    const user = JSON.parse(localStorage.getItem('user'));
    const username = user ? user.username : null;

    const handleButtonClickDown = () => {
        navigate('/Developing'); // Navigate to the link corresponding to the current image
    };

    const handleButtonClickWms = () => {
        navigate('/Developing'); // Navigate to the link corresponding to the current image
    };

    const handleButtonClickcore = () => {
        navigate('/Developing'); // Navigate to the link corresponding to the current image
    };

    const handleButtonClickCPT = () => {
        navigate('/ves_cpt'); // Navigate to the link corresponding to the current image
    };

    const handleButtonClickelab = () => {
        navigate('/Developing'); // Navigate to the link corresponding to the current image
    };

    const handleButtonClickSondaggio = () => {
        navigate('/ves_borehole'); // Navigate to the link corresponding to the current image
    };

    const handleButtonClickGuide = () => {
        navigate('/guide'); // Navigate to the link corresponding to the current image
    };

    const handleButtonClickTut = () => {
        navigate('/ves_tutorial'); // Navigate to the link corresponding to the current image
    };



    return(
        <div className="main-wrapper">
            <div className="tools-wrapperS1" id="id1">
                <div className="title-sez1">Cosa vuoi elaborare?</div>
                <div className="sez1" >
                    <div className="bloc-cont">
                        <div className="ic1" onClick={handleButtonClickCPT} style={{ cursor: 'pointer' }}>
                            <div className="ic1-block">
                                <h3 className="preview-title">CPT</h3>
                            </div>
                            <div className="ic1-block">
                                    <img src={cptimg} alt="icon" style={{ width: '168px', height: 'auto', display: 'block', margin: '0 auto' }} />
                            </div>
                            <div className="ic1-block">
                            </div>
                        </div>
                        <div className="ic1" onClick={handleButtonClickcore} style={{ cursor: 'pointer' }}>
                            <div className="ic1-block">
                                <h3 className="preview-title">DIN</h3>
                            </div>
                            <div className="ic1-block">
                                    <img src={dvp} alt="icon" style={{ width: '168px', height: 'auto', display: 'block', margin: '0 auto' }} />

                            </div>
                            <div className="ic1-block">
                            </div>
                        </div>

                        <div className="ic1" onClick={handleButtonClickelab} style={{ cursor: 'pointer' }}>
                            <div className="ic1-block">
                                <h3 className="preview-title">DMT</h3>
                            </div>
                            <div className="ic1-block">
                                    <img src={dvp} alt="icon" style={{ width: '168px', height: 'auto', display: 'block', margin: '0 auto' }} />

                            </div>
                            <div className="ic1-block">
                            </div>
                        </div>

                        <div className="ic1" onClick={handleButtonClickSondaggio} style={{ cursor: 'pointer' }}>
                            <div className="ic1-block">
                                <h3 className="preview-title">SONDAGGIO</h3>
                            </div>
                            <div className="ic1-block">
                                    <img src={borimg} alt="icon" style={{ width: '250px', height: 'auto', display: 'block', margin: '0 auto' }} />
                            </div>
                            <div className="ic1-block">
                            </div>
                        </div>
                     </div>
                </div>
            </div>

            <div className="tools-wrapperS2" id="id2">
                <div className="sez2" >
                    <div className="bloc-cont">
                        <div className="ic1" onClick={handleButtonClickDown} style={{ cursor: 'pointer' }}>
                            <div className="ic1-block">
                                <h3 className="preview-title">HVSR</h3>
                            </div>
                            <div className="ic1-block">
                                   <img src={dvp} alt="icon" style={{ width: '168px', height: 'auto', display: 'block', margin: '0 auto' }} />
                            </div>
                            <div className="ic1-block">
                            </div>
                        </div>
                        <div className="ic1" onClick={handleButtonClickDown} style={{ cursor: 'pointer' }}>
                            <div className="ic1-block">
                                <h3 className="preview-title">MASW</h3>
                            </div>
                            <div className="ic1-block">
                                    <img src={dvp} alt="icon" style={{ width: '168px', height: 'auto', display: 'block', margin: '0 auto' }} />
                            </div>
                            <div className="ic1-block">
                            </div>
                        </div>

                        <div className="ic1" onClick={handleButtonClickGuide} style={{ cursor: 'pointer' }}>
                            <div className="ic1-block">
                                <h3 className="preview-title">GUIDE & MANUALI</h3>
                            </div>
                            <div className="ic1-block">
                                    <img src={gd} alt="icon" style={{ width: '100px', height: 'auto', display: 'block', margin: '0 auto' }} />
                            </div>
                            <div className="ic1-block">
                            </div>
                        </div>

                        <div className="ic1" onClick={handleButtonClickTut} style={{ cursor: 'pointer' }}>
                            <div className="ic1-block">
                                <h3 className="preview-title">TUTORIAL</h3>
                            </div>
                            <div className="ic1-block">
                                    <img src={tut} alt="icon" style={{ width: '200px', height: 'auto', display: 'block', margin: '0 auto' }} />
                            </div>
                            <div className="ic1-block">
                            </div>
                        </div>
                     </div>
                </div>
            </div>
      </div>

    );
}


export default Sw_dash;

